import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteValidationMessage } from '../../../../_global/fragments/generated/CompleteValidationMessage';
import { ShareName } from '../../fragments/generated/ShareName';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type BulkDeleteShareMutationVariables = Types.Exact<{
  input: Types.BulkDeleteSharesInput;
}>;


export type BulkDeleteShareMutation = { __typename?: 'Mutation', bulkDeleteShares?: { __typename?: 'BulkDeleteSharesPayload', results: Array<{ __typename?: 'BulkDeleteShareItemPayload', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null }> | null, result?: { __typename?: 'AdHocAssetsShare', id: string, name: string } | { __typename?: 'CollectionShare', id: string, name: string } | null }> } | null };


export const BulkDeleteShare = /*#__PURE__*/ gql`
    mutation BulkDeleteShare($input: BulkDeleteSharesInput!) {
  bulkDeleteShares(input: $input) {
    results {
      successful
      messages {
        ...CompleteValidationMessage
      }
      result {
        ...ShareName
      }
    }
  }
}
    ${CompleteValidationMessage}
${ShareName}` as unknown as DocumentNode<BulkDeleteShareMutation, BulkDeleteShareMutationVariables>;

          

          export const useBulkDeleteShareMutation = (options?:MutationHookOptions<BulkDeleteShareMutation, BulkDeleteShareMutationVariables>) => useMutation(BulkDeleteShare, options);
          

          export type BulkDeleteShareMutationOptions = MutationHookOptions<BulkDeleteShareMutation, BulkDeleteShareMutationVariables>;

          

          export type BulkDeleteShareMutationResult = ReturnType<typeof useBulkDeleteShareMutation>[1];

          
